import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse, ApiListResponse } from '../lib/response';

import { Waitlist } from '../models/waitlist';

export class WaitlistService extends BaseService<Waitlist> {
  override model = Waitlist;
  override modelName = 'waitlist';
  override modelLabel = 'Waitlist';

  async create({
    customer,
    services,
    dates,
  }: {
    customer: { idCustomer: number };
    services: { service?: { idService: number } | null; employee?: { idEmployee: number } | null }[];
    dates: any[];
  }): Promise<ApiResponse<Waitlist>> {
    const request = new ApiRequest({
      method: 'POST',
      url: this.modelBaseUrl,
      data: {
        dates,
        customer: { id: customer.idCustomer },
        services: services.map((service) => ({
          service: service.service?.idService || null,
          employee: service.employee?.idEmployee || null,
        })),
      },
    });

    return await this.requestItem(request, Waitlist);
  }

  async filtered({
    page = 1,
    limit = 100,
    filter,
  }: {
    page?: number;
    limit?: number;
    filter?: string | null;
  } = {}): Promise<ApiListResponse<Waitlist>> {
    const query: Record<string, string> = {
      page: page.toString(),
      limit: limit.toString(),
    };

    if (filter) {
      query.filter = filter;
    }

    const request = new ApiRequest({
      method: 'GET',
      url: this.modelBaseUrl,
      query,
    });

    return await this.requestList(request, Waitlist);
  }

  async cancel(
    waitlist: Waitlist,
  ): Promise<ApiResponse<Waitlist>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/${waitlist.objectID()}/cancel`,
    });

    return await this.requestItem(request, Waitlist);
  }

  async email(
    waitlist: Waitlist,
  ): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/${waitlist.objectID()}/email`,
    });

    return await this.requestItem(request, Waitlist);
  }

  async notify(
    waitlist: Waitlist,
  ): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/${waitlist.objectID()}/notify`,
    });

    return await this.requestItem(request, Waitlist);
  }
}
